import { call, put } from "redux-saga/effects";
import { ACTIONS, APIS, KEYS, STORAGE } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* searchVendor(action: any): any {
    const yieldPuts = [{ type: ACTIONS.VENDORS.SEARCH_VENDOR, payload: "items" }];
    yield call(sagaFunction, action, CallApi.POST, APIS.VENDORS.SEARCH_VENDOR, action.payload, true, yieldPuts);
}

export function* addUpdateVendor(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.VENDORS.ADD_UPDATE_VENDOR, action.payload, true);
}

export function* deleteVendor(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.VENDORS.DELETE_VENDOR, action.payload, true);
}

export function* vendorDetails(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.VENDORS.VENDOR_DETAILS + action.payload, null, true);
}

export function* checkSKUUnique(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.VENDORS.CHECK_SKU_UNIQUE, action.payload, true);
}
